
import React, { useState } from 'react';
import { LEGAL_CONTENT } from '../legalContent';

interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'terms' | 'privacy';
}

const LegalModal: React.FC<LegalModalProps> = ({ isOpen, onClose, type }) => {
  if (!isOpen) return null;

  const active = LEGAL_CONTENT[type];

  return (
    <div className="fixed inset-0 z-[400] flex flex-col bg-white dark:bg-slate-900 sm:bg-slate-950/60 sm:backdrop-blur-md sm:items-center sm:justify-center sm:p-4 animate-in fade-in duration-300">
      <div className="flex-1 flex flex-col w-full sm:max-w-5xl sm:h-auto sm:max-h-[92vh] sm:rounded-[2rem] shadow-2xl overflow-hidden sm:border border-slate-200 dark:border-white/10">
        {/* Header - More compact on mobile */}
        <div className="px-4 py-3 sm:px-8 sm:py-6 border-b border-slate-100 dark:border-slate-800 flex justify-between items-center bg-slate-50/50 dark:bg-slate-800/50">
          <h3 className="text-base sm:text-2xl font-black text-slate-900 dark:text-slate-100 uppercase tracking-tight">{active.title}</h3>
          <button onClick={onClose} className="w-8 h-8 sm:w-12 sm:h-12 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-500 dark:text-slate-300 flex items-center justify-center active:scale-90 transition-all">
            <i className="fa-solid fa-times text-sm sm:text-base"></i>
          </button>
        </div>
        
        {/* Content Area - Maximize space */}
        <div className="flex-1 overflow-y-auto relative bg-white dark:bg-slate-900 p-6 sm:p-12 hide-scrollbar text-slate-600 dark:text-slate-400 text-sm sm:text-base">
          {active.text}
        </div>

        {/* Footer - Minimal on mobile */}
        <div className="px-4 py-2 sm:py-4 bg-slate-50 dark:bg-slate-800/50 border-t border-slate-100 dark:border-slate-800 text-center pb-[calc(0.5rem+env(safe-area-inset-bottom))] sm:pb-4">
           <p className="text-[8px] sm:text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Equilibra Finance • Soberania de Dados</p>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;